import React from 'react';
import {OverlayScrollbarsComponentRef} from 'overlayscrollbars-react/types/OverlayScrollbarsComponent';

export const scrollContent = (osRef: React.MutableRefObject<OverlayScrollbarsComponentRef<'div'>>) => {
	const {current} = osRef;
	const osInstance = current?.osInstance();

	if (!osInstance) {
		return;
	}

	const {overflowAmount} = osInstance.state();
	const {scrollOffsetElement} = osInstance.elements();
	const {scrollTop} = scrollOffsetElement;

	if (scrollTop) {
		scrollOffsetElement.scrollTo({
			top: Math.round((overflowAmount.y - scrollTop) / overflowAmount.y) * overflowAmount.y,
		});
	}
};